"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWidgetExpanded = exports.hasNewNotifications = exports.getNotifications = exports.getNextToken = exports.getError = void 0;
const getNotifications = state => state.notifications.entities;
exports.getNotifications = getNotifications;
const getNextToken = state => state.notifications.nextToken;
exports.getNextToken = getNextToken;
const getError = state => state.notifications.error;
exports.getError = getError;
const isWidgetExpanded = state => state.notifications.isWidgetExpanded;
exports.isWidgetExpanded = isWidgetExpanded;
const hasNewNotifications = state => {
  const notifications = getNotifications(state);
  const unread = notifications.filter(n => !n.isRead);
  return !!unread.length;
};
exports.hasNewNotifications = hasNewNotifications;